import { Component, Inject, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  GestoresResiduosControllerService,
  GestoresResiduosEstadosControllerService,
} from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { WasteManagersBajaMotivoDialogComponent } from '../waste-managers-baja-motivo-dialog/waste-managers-baja-motivo-dialog.component';

const ESTADO_BAJA_ID = 3;

@Component({
  selector: 'lib-waste-managers-status-change-dialog',
  templateUrl: './waste-managers-status-change-dialog.component.html',
  styleUrls: ['./waste-managers-status-change-dialog.component.scss'],
})
export class WasteManagersStatusChangeDialogComponent implements OnInit {
  estados: any[] = [];
  gestores: any[] = [];
  estadoActual: any;

  formGroup!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<WasteManagersStatusChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private gestoresResiduosEstadosControllerService: GestoresResiduosEstadosControllerService,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService
  ) {
    this.gestores = this.data.gestores;
    this.estadoActual = this.data.estadoActual;

    this.formGroup = this.formBuilder.group({
      estado: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
    });
  }

  ngOnInit(): void {
    this.cargarEstados();
    this.cargarEstadoActual();
  }

  cargarEstados(): void {
    this.gestoresResiduosEstadosControllerService.findAll9().subscribe({
      next: (data: any) => {
        this.estados = data!;
      },
      error: () => {},
    });
  }

  cargarEstadoActual() {
    this.formGroup.get('estado')?.setValue(this.estadoActual);
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      const estadoId = this.formGroup.get('estado')?.value;

      if (estadoId === ESTADO_BAJA_ID) {
        this.abrirDialogoMotivoBaja();
      } else {
        this.actualizarEstadoGestores(estadoId);
      }
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  private abrirDialogoMotivoBaja(): void {
    const dialogRef = this.dialog.open(WasteManagersBajaMotivoDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        gestores: this.gestores,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.darBajaGestores();
      }
    });
  }

  private darBajaGestores(): void {
    const gestoresId = this.gestores.map((x) => x.id);
    this.spinnerSrv.loadingShow();

    forkJoin(
      gestoresId.map((id: any) =>
        this.gestoresResiduosControllerService.bajaGestorResiduo(id)
      )
    ).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(
          'Se ha cambiado el estado de los gestores/acondicionadores seleccionados.',
          'success'
        );
      },
      error: (err: { message: any }) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al cambiar el estado de los gestores/acondicionadores',
          'error'
        );
      },
    });
  }

  private actualizarEstadoGestores(estadoId: number): void {
    const gestoresId = this.gestores.map((x) => x.id);
    this.spinnerSrv.loadingShow();

    this.gestoresResiduosControllerService
      .multipleActualizarEstado1(estadoId, gestoresId)
      .subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close(true);
          let mensaje =
            'Se ha cambiado el estado de los gestores/acondicionadores seleccionados.';
          if (value && value.length > 0) {
            mensaje = mensaje + '\n' + value.join('\n');
          }
          this.snackBarSrv.showSnackBar(mensaje, 'success');
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al cambiar el estado de los gestores/acondicionadores',
            'error'
          );
        },
      });
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  controlHasErrorSelect(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }
}
